import { useEffect, useState } from "react";
import EstadoBadge from "../components/EstadoBadge";
import Loader from "../components/Loader";
import {
  listUsuariosLazy,
  updateUsuarios,
  createUsuarios,
  changeUsuarios,
} from "../api/usuarios";

import {
  listUsuariosAcceso
} from "../api/usuarioSucursales"

const Usuarios = () => {
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [usuarios, setusuarios] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [accesosPorUsuario, setAccesosPorUsuario] = useState({});

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [limit, setLimit] = useState(10);
  const [buscar, setBuscar] = useState("");

  const [form, setForm] = useState({
    codigo: "",
    username: "",
    nombre: "",
    apellido: "",
    correo: "",
    telefono: "",
    password: "",
    status: "",
    dui: "",
    nit: "",
  });


  const fetchData = async (p = 1) => {
    try {
      const data = await listUsuariosLazy(p, limit, buscar);
      setusuarios(data.data);

      for (const usuario of data.data) {
        usuarioSucursales(usuario);
      }

      setTotalPages(data.totalPages);
      setPage(data.currentPage);

    } catch (error) {
      console.error("Error al obtener las categorías", error);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    fetchData(page);
    // eslint-disable-next-line 
  }, [page, limit, buscar]);


  // Manejar cambios de campos del formulario
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  // Abrir modal para nueva categoría
  const openModalForNew = () => {
    setForm({ name: "", description: "", status: "" });
    setEditMode(false);
    setCurrentId(null);
    setShowModal(true);
  };

  // Abrir modal para editar categoría
  const openModalForEdit = (usuario) => {
    setForm({
      codigo: usuario.codigo || "",
      username: usuario.username || "",
      nombre: usuario.nombre || "",
      apellido: usuario.apellido || "",
      dui: usuario.dui || "",
      nit: usuario.nit || "",
      correo: usuario.correo || "",
      telefono: usuario.telefono || "",
      password: usuario.password || "",
      status: String(usuario.status ?? ""),

    });
    setCurrentId(usuario.id);
    setEditMode(true);
    setShowModal(true);
  };

  // Guardar o actualizar categoría
  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const data = {
        codigo: form.codigo,
        username: form.username,
        nombre: form.nombre,
        apellido: form.apellido,
        dui: form.dui,
        nit: form.nit,
        correo: form.correo,
        telefono: form.telefono,
        password: form.password,
        status: form.status,
      };

      if (editMode) {
        await updateUsuarios(currentId, data);
      } else {
        await createUsuarios(data);
      }

      await fetchData();
      setShowModal(false);
    } catch (error) {
      console.error("Error al guardar la categoría", error);
    } finally {
      setSubmitting(false);
    }
  };

  // Cambiar estado de una categoría
  const handleToggleStatus = async (usuario) => {
    const newStatus = usuario.status === 1 ? 0 : 1;
    try {
      await changeUsuarios(usuario.id, { status: newStatus });
      await fetchData();
    } catch (error) {
      console.error("Error al cambiar el estado de la categoría", error);
    }
  };


  const usuarioSucursales = async (usuario) => {
    try {
      const res = await listUsuariosAcceso(usuario.id);
      console.log("Respuesta de accesos:", res);
      setAccesosPorUsuario((prev) => ({
        ...prev,
        [usuario.id]: res.data || [],
      }));
    } catch (error) {
      console.error("Error al listar acceso del usuario", error);
    }
  };


  if (loading) return <Loader />;

  return (
    <div className="p-3 sm:p-6 max-w-7xl mx-auto">
      {/* Encabezado */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mb-4 sm:mb-6 gap-3">
        <div>
          <h2 className="text-xl sm:text-2xl font-bold text-slate-800">Gestión de Usuarios</h2>
          <p className="text-xs sm:text-sm text-slate-500 mt-1">Administre los accesos y credenciales del sistema</p>
        </div>
        <button
          onClick={openModalForNew}
          className="w-full sm:w-auto bg-indigo-600 text-white px-4 py-2.5 rounded-lg hover:bg-indigo-700 transition-colors shadow-sm shadow-indigo-200 font-medium flex items-center justify-center gap-2"
        >
          <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
          </svg>
          Agregar Usuario
        </button>
      </div>

      {/* Filtros */}
      <div className="flex flex-col sm:flex-row sm:flex-wrap sm:items-center gap-3 mb-4 sm:mb-6 bg-white p-3 sm:p-4 rounded-xl shadow-sm border border-slate-200">
        <div className="relative flex-grow">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <svg className="h-5 w-5 text-slate-400" viewBox="0 0 20 20" fill="currentColor">
              <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
            </svg>
          </div>
          <input
            type="text"
            placeholder="Buscar usuario por nombre, correo..."
            value={buscar}
            onChange={(e) => setBuscar(e.target.value)}
            className="pl-10 pr-4 py-2 w-full border border-slate-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors bg-slate-50 focus:bg-white text-sm"
          />
        </div>

        <div className="flex items-center gap-2">
          <span className="text-sm text-slate-500 font-medium whitespace-nowrap">Mostrar:</span>
          <select
            value={limit}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setPage(1);
            }}
            className="border border-slate-300 rounded-lg px-3 py-2 bg-white focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
          >
            {[10, 15, 25, 50, 100, 250, 500, 1000].map(num => (
              <option key={num} value={num}>
                {num} registros
              </option>
            ))}
          </select>
        </div>
      </div>


      {/* Tabla de usuarios */}
      <div className="hidden md:block bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div className="overflow-x-auto custom-scrollbar">
          <table className="w-full text-sm text-left">
            <thead className="text-xs text-slate-500 bg-slate-50 uppercase border-b border-slate-200">
              <tr>
                <th className="px-4 py-3 font-semibold">Codigo</th>
                <th className="px-4 py-3 font-semibold">UserName</th>
                <th className="px-4 py-3 font-semibold">Nombre</th>
                <th className="px-4 py-3 font-semibold">Apellido</th>
                <th className="px-4 py-3 font-semibold">Dui</th>
                <th className="px-4 py-3 font-semibold">Nit</th>
                <th className="px-4 py-3 font-semibold">Correo</th>
                <th className="px-4 py-3 font-semibold">Telefono</th>
                <th className="px-4 py-3 font-semibold">Accesos</th>
                <th className="px-4 py-3 font-semibold text-center">Estado</th>
                <th className="px-4 py-3 font-semibold text-center sticky right-0 bg-slate-100 border-l border-slate-200 z-10 shadow-[-4px_0_6px_-2px_rgba(0,0,0,0.05)]">Opciones</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {usuarios.map((usuario) => (
                <tr
                  key={usuario.id}
                  className="hover:bg-indigo-50/50 transition-colors group"
                >
                  <td className="px-4 py-3 text-slate-600 font-medium whitespace-nowrap">{usuario.codigo}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{usuario.username}</td>
                  <td className="px-4 py-3 text-slate-700 font-medium whitespace-nowrap">{usuario.nombre}</td>
                  <td className="px-4 py-3 text-slate-700 font-medium whitespace-nowrap">{usuario.apellido}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{usuario.dui}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{usuario.nit}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{usuario.correo}</td>
                  <td className="px-4 py-3 text-slate-600 whitespace-nowrap">{usuario.telefono}</td>
                  <td className="px-4 py-3 text-xs">
                    {accesosPorUsuario[usuario.id] ? (
                      accesosPorUsuario[usuario.id].length > 0 ? (
                        <div className="space-y-1.5 min-w-[200px]">
                          {accesosPorUsuario[usuario.id].map((acceso, idx) => (
                            <div
                              key={idx}
                              className={`px-2 py-1.5 rounded-md border text-[11px] font-medium animate-fade-in ${acceso.estado === "Inactivo"
                                ? "bg-red-50 border-red-100 text-red-700"
                                : "bg-emerald-50 border-emerald-100 text-emerald-700"
                                }`}
                            >
                              <strong className="text-slate-800">{acceso.sucursal}</strong> - <span className="text-slate-600">{acceso.permisos}</span> ({acceso.estado})
                            </div>
                          ))}
                        </div>
                      ) : (<span className="text-slate-400 italic">Sin sucursales asignadas</span>)
                    ) : (<span className="text-slate-400 italic flex items-center gap-1"><span className="w-3 h-3 border-2 border-slate-300 border-t-slate-500 rounded-full animate-spin"></span> Cargando...</span>)}
                  </td>
                  <td className="px-4 py-3 text-center">
                    <EstadoBadge status={usuario.status} />
                  </td>
                  <td className="px-4 py-3 text-center sticky right-0 bg-slate-100 group-hover:bg-slate-200 border-l border-slate-200 z-0 shadow-[-4px_0_6px_-2px_rgba(0,0,0,0.03)] transition-colors">
                    <div className="flex items-center justify-center gap-2">
                      <button
                        type="button"
                        onClick={() => openModalForEdit(usuario)}
                        className="bg-white border border-slate-200 text-slate-600 px-3 py-1.5 rounded-lg hover:bg-slate-50 hover:text-indigo-600 transition-colors text-xs font-medium"
                      >
                        Editar
                      </button>

                      {usuario.status === 1 ? (
                        <button
                          type="button"
                          onClick={() => handleToggleStatus(usuario)}
                          className="bg-red-50 text-red-600 border border-red-100 px-3 py-1.5 rounded-lg hover:bg-red-100 transition-colors text-xs font-medium"
                        >
                          Deshabilitar
                        </button>
                      ) : (
                        <button
                          type="button"
                          onClick={() => handleToggleStatus(usuario)}
                          className="bg-emerald-50 text-emerald-600 border border-emerald-100 px-3 py-1.5 rounded-lg hover:bg-emerald-100 transition-colors text-xs font-medium"
                        >
                          Activar
                        </button>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Cards — solo en móvil */}
      <div className="md:hidden space-y-3">
        {usuarios.map((usuario) => (
          <div key={usuario.id} className="bg-white rounded-xl border border-slate-200 shadow-sm p-4">
            {/* Cabecera */}
            <div className="flex items-start justify-between gap-2 mb-3">
              <div className="flex-1 min-w-0">
                <p className="font-semibold text-slate-800 text-sm">
                  {usuario.nombre} {usuario.apellido}
                </p>
                <p className="text-xs text-slate-500 truncate">@{usuario.username}</p>
              </div>
              <EstadoBadge status={usuario.status} />
            </div>

            {/* Datos en grid 2 columnas */}
            <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs mb-3">
              {usuario.codigo && (
                <div>
                  <span className="text-slate-400 font-medium uppercase tracking-wide">Código</span>
                  <p className="text-slate-700 font-medium">{usuario.codigo}</p>
                </div>
              )}
              {usuario.correo && (
                <div className="col-span-2">
                  <span className="text-slate-400 font-medium uppercase tracking-wide">Correo</span>
                  <p className="text-slate-700 font-medium truncate">{usuario.correo}</p>
                </div>
              )}
              {usuario.telefono && (
                <div>
                  <span className="text-slate-400 font-medium uppercase tracking-wide">Teléfono</span>
                  <p className="text-slate-700 font-medium">{usuario.telefono}</p>
                </div>
              )}
              {usuario.dui && (
                <div>
                  <span className="text-slate-400 font-medium uppercase tracking-wide">DUI</span>
                  <p className="text-slate-700 font-medium">{usuario.dui}</p>
                </div>
              )}
            </div>

            {/* Accesos */}
            {accesosPorUsuario[usuario.id] ? (
              accesosPorUsuario[usuario.id].length > 0 ? (
                <div className="space-y-1 mb-3">
                  {accesosPorUsuario[usuario.id].map((acceso, idx) => (
                    <div
                      key={idx}
                      className={`px-2 py-1.5 rounded-md border text-[11px] font-medium ${acceso.estado === "Inactivo"
                        ? "bg-red-50 border-red-100 text-red-700"
                        : "bg-emerald-50 border-emerald-100 text-emerald-700"
                        }`}
                    >
                      <strong className="text-slate-800">{acceso.sucursal}</strong> — <span className="text-slate-600">{acceso.permisos}</span>
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-xs text-slate-400 italic mb-3">Sin sucursales asignadas</p>
              )
            ) : (
              <p className="text-xs text-slate-400 italic flex items-center gap-1 mb-3">
                <span className="w-3 h-3 border-2 border-slate-300 border-t-slate-500 rounded-full animate-spin"></span>
                Cargando accesos...
              </p>
            )}

            {/* Acciones */}
            <div className="flex gap-2 pt-3 border-t border-slate-100">
              <button
                type="button"
                onClick={() => openModalForEdit(usuario)}
                className="flex-1 bg-white border border-slate-200 text-slate-600 py-2 rounded-lg hover:bg-slate-50 hover:text-indigo-600 transition-colors text-xs font-medium text-center"
              >
                Editar
              </button>
              {usuario.status === 1 ? (
                <button
                  type="button"
                  onClick={() => handleToggleStatus(usuario)}
                  className="flex-1 bg-red-50 text-red-600 border border-red-100 py-2 rounded-lg hover:bg-red-100 transition-colors text-xs font-medium text-center"
                >
                  Deshabilitar
                </button>
              ) : (
                <button
                  type="button"
                  onClick={() => handleToggleStatus(usuario)}
                  className="flex-1 bg-emerald-50 text-emerald-600 border border-emerald-100 py-2 rounded-lg hover:bg-emerald-100 transition-colors text-xs font-medium text-center"
                >
                  Activar
                </button>
              )}
            </div>
          </div>
        ))}
      </div>

      {/* Paginación */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center mt-4 sm:mt-6 px-1 gap-3">
        <p className="text-sm text-slate-500 text-center sm:text-left">
          Página <span className="font-medium">{page}</span> de <span className="font-medium">{totalPages}</span>
        </p>
        <div className="flex gap-1 bg-white p-1 rounded-lg border border-slate-200 justify-center overflow-x-auto">
          <button
            disabled={page === 1}
            onClick={() => fetchData(page - 1)}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${page === 1
              ? "text-slate-400 cursor-not-allowed"
              : "text-slate-600 hover:bg-slate-100"
              }`}
          >
            ← Ant
          </button>

          {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => {
            if (totalPages > 7) {
              if (num === 1 || num === totalPages || (num >= page - 1 && num <= page + 1)) {
                return (
                  <button
                    key={num}
                    onClick={() => fetchData(num)}
                    className={`min-w-[32px] px-2 py-1.5 rounded-md text-sm font-medium transition-colors ${page === num
                      ? "bg-indigo-50 text-indigo-600"
                      : "text-slate-600 hover:bg-slate-100"
                      }`}
                  >
                    {num}
                  </button>
                );
              } else if (num === page - 2 || num === page + 2) {
                return <span key={num} className="px-2 py-1.5 text-slate-400">...</span>;
              }
              return null;
            }

            return (
              <button
                key={num}
                onClick={() => fetchData(num)}
                className={`min-w-[32px] px-2 py-1.5 rounded-md text-sm font-medium transition-colors ${page === num
                  ? "bg-indigo-50 text-indigo-600"
                  : "text-slate-600 hover:bg-slate-100"
                  }`}
              >
                {num}
              </button>
            )
          })}

          <button
            disabled={page === totalPages}
            onClick={() => fetchData(page + 1)}
            className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${page === totalPages
              ? "text-slate-400 cursor-not-allowed"
              : "text-slate-600 hover:bg-slate-100"
              }`}
          >
            Sig →
          </button>
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm flex justify-center items-start sm:items-center z-50 p-2 sm:p-6 overflow-y-auto">
          <div className="bg-white rounded-2xl shadow-xl w-full max-w-4xl flex flex-col my-4 sm:my-8 animate-fade-in-up">
            <div className="flex items-center justify-between p-4 sm:p-6 border-b border-slate-100">
              <div className="flex items-center gap-3">
                <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-indigo-50 flex items-center justify-center text-indigo-600 shrink-0">
                  <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                </div>
                <h3 className="text-base sm:text-xl font-bold text-slate-800">
                  {editMode ? "Actualizar Usuario" : "Registrar Nuevo Usuario"}
                </h3>
              </div>
              <button onClick={() => setShowModal(false)} className="text-slate-400 hover:text-slate-600 transition-colors p-1">
                <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="p-4 sm:p-6 overflow-y-auto custom-scrollbar max-h-[65vh]">
              <form onSubmit={handleSubmit} id="usuario-form" className="space-y-4 sm:space-y-6">
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Código de Empleado</label>
                    <input
                      type="text"
                      name="codigo"
                      value={form.codigo}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                      required
                    />
                  </div>
                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Nombre de Usuario</label>
                    <input
                      type="text"
                      name="username"
                      value={form.username}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                      required
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Nombres</label>
                    <input
                      type="text"
                      name="nombre"
                      value={form.nombre}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                      required
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Apellidos</label>
                    <input
                      type="text"
                      name="apellido"
                      value={form.apellido}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                      required
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">DUI</label>
                    <input
                      type="text"
                      name="dui"
                      value={form.dui}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                      required
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">NIT</label>
                    <input
                      type="text"
                      name="nit"
                      value={form.nit}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                      required
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Correo Electrónico</label>
                    <input
                      type="email"
                      name="correo"
                      value={form.correo}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                      required
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Teléfono</label>
                    <input
                      type="text"
                      name="telefono"
                      value={form.telefono}
                      onChange={handleChange}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                      required
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">
                      {editMode ? "Nueva Contraseña (Opcional)" : "Contraseña"}
                    </label>
                    <input
                      type="password"
                      name="password"
                      value={form.password}
                      onChange={handleChange}
                      placeholder={editMode ? "Dejar en blanco para mantener actual" : ""}
                      className="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors text-sm"
                      required={!editMode}
                    />
                  </div>

                  <div>
                    <label className="block mb-2 text-sm font-semibold text-slate-700">Estado de la Cuenta</label>
                    <select
                      name="status"
                      value={form.status}
                      onChange={handleChange}
                      className={`w-full border border-slate-300 rounded-lg px-4 py-2.5 font-medium transition-colors focus:ring-2 focus:ring-indigo-500 outline-none text-sm ${form.status === "1"
                        ? "bg-emerald-50 text-emerald-700 border-emerald-200"
                        : form.status === "0"
                          ? "bg-rose-50 text-rose-700 border-rose-200"
                          : "bg-white text-slate-700"
                        }`}
                      required
                    >
                      <option value="" disabled>Seleccione un estado...</option>
                      <option value="1">Activo</option>
                      <option value="0">Inactivo</option>
                    </select>
                  </div>
                </div>
              </form>
            </div>

            <div className="p-4 sm:p-6 border-t border-slate-100 bg-slate-50 flex flex-col-reverse sm:flex-row sm:items-center sm:justify-end gap-2 sm:gap-3 rounded-b-2xl">
              <button
                type="button"
                onClick={() => setShowModal(false)}
                className="w-full sm:w-auto px-5 py-2.5 rounded-lg border border-slate-300 text-slate-700 font-medium hover:bg-white focus:ring-2 focus:ring-slate-200 transition-colors text-sm"
                disabled={submitting}
              >
                Cancelar
              </button>

              <button
                type="submit"
                form="usuario-form"
                disabled={submitting}
                className={`w-full sm:w-auto px-6 py-2.5 rounded-lg flex items-center justify-center gap-2 font-medium shadow-sm transition-all text-sm ${submitting
                  ? "bg-indigo-400 cursor-not-allowed shadow-none"
                  : "bg-indigo-600 hover:bg-indigo-700 hover:shadow-indigo-200"
                  } text-white`}
              >
                {submitting && (
                  <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
                )}
                {submitting
                  ? editMode
                    ? "Actualizando..."
                    : "Guardando..."
                  : editMode
                    ? "Actualizar Usuario"
                    : "Guardar Usuario"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Usuarios;
